import { createContext, useContext } from 'react';
import { action, observable } from 'mobx';

type Required<T> = {
  value: T;
  error: string;
};

const emptyValue = { error: '', value: '' };

class ArticleBudgetCap {
  @observable id = '';
  @observable isSubmitting = false;
  @observable editMode = false;
  @observable budgetCapDollars: Required<string> = {
    value: '',
    error: ''
  };

  @action init = (id: string, budgetCapDollars: number) => {
    this.editMode = true;
    this.id = id;
    this.budgetCapDollars.value = budgetCapDollars.toString();
  };

  @action reset = () => {
    this.id = '';
    this.isSubmitting = false;
    this.editMode = false;
    this.budgetCapDollars = emptyValue;
  };

  @action handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.budgetCapDollars = {
      error: ' ',
      value: event.target.value
    };
  };

  @action getValuesBeforeUpdate = (ids: string[]) => {
    this.isSubmitting = true;
    return {
      articleIds: ids,
      budgetCap: Number(this.budgetCapDollars.value)
    };
  };
}

export const ArticleBudgetCapContext = createContext(new ArticleBudgetCap());

export const useArticleBudgetCapContext = () => useContext(ArticleBudgetCapContext);

export default ArticleBudgetCap;
